<template>
    <div>
        <div style="text-align: right">
            <el-button icon="el-icon-plus" type="danger" @click="openCreateBlackDialog">添 加</el-button>
        </div>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 10px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="coinType" label="交易币种"></el-table-column>
            <el-table-column prop="continuedHour" label="状态持续时间（时）"></el-table-column>
            <el-table-column prop="blacklistStatus" label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.blacklistStatus==0">已拉黑</span>
                    <span v-if="scope.row.blacklistStatus==1">已解除</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="280px">
                <template slot-scope="scope">
                    <el-button type="danger" v-if="scope.row.blacklistStatus==1" @click="handleStatus(scope.row.id,0)">
                        拉黑
                    </el-button>
                    <el-button type="danger" v-if="scope.row.blacklistStatus==0" @click="handleStatus(scope.row.id,1)">
                        解除
                    </el-button>
                    <el-button type="primary" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="danger" @click="handleRemove(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <el-form label-width="100px" :model="addData" :rules="addDataRules" ref="addDataForm">
                <el-form-item label="交易币种：" prop="coinList">
                    <el-autocomplete class="inline-input"
                                     v-model="addData.coinList"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="时间：" prop="continuedHour" style="width: 400px">
                    <el-select v-model="addData.type" placeholder="请选择" @change="selectType($event)"
                               style="width: 80px;display: inline-block">
                        <el-option label="小时" :value="1"></el-option>
                        <el-option label="永久" :value="-1"></el-option>
                    </el-select>
                    <el-input placeholder="请输入内容" v-model="addData.continuedHour" class="input-with-select"
                              style="width: 200px;display: inline-block"
                              :disabled="addData.type==-1">
                    </el-input>
                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="createBlack">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: "upBlackList",
        data() {
            return {
                dataList: [],
                total: 0,
                coinTypes: [],
                addData: {configType: 1, coinList: "", continuedHour: -1, type: -1},
                addDataRules: {
                    "coinType": [{required: true, message: "币种不能为空"}],
                    "continuedHour": [{pattern: /^[+]{0,1}(\d+)$/, message: "请输入正整数"},
                        {required: true, message: '请输入时间'},
                        {min: 1, message: '请输入不少于1个数字'}],
                },
                dialogTitle: "",
                dialogVisible: false,
                queryParams: { //查询参数
                    configType: 1,
                    page: 1,
                    size: 10
                },
                opType: 0 //0-新增，1-修改
            };
        },
        methods: {
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getUpBlackList() {
                api.getEtpCoinConfigList(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            openCreateBlackDialog() {
                this.dialogTitle = "新增";
                this.opType = 0;
                this.dialogVisible = true;
            },
            handleUpdate(row) {
                this.addData = {
                    configId: row.id,
                    coinList: row.coinType,
                    configType: 1,
                    continuedHour: row.continuedHour,
                    type: row.continuedHour == -1 ? -1 : 1
                };
                this.dialogTitle = "修改";
                this.opType = 1;
                this.dialogVisible = true;
            },
            createBlack() {
                this.$refs["addDataForm"].validate(valid => {
                    if (valid) {
                        if (this.opType == 0) {
                            api.saveEtpCoinConfig(this.addData).then(({data}) => {
                                this.dialogVisible = false;
                                this.$message.success('保存成功！');
                                this.getUpBlackList();
                            });
                        } else {
                            api.updateEtpCoinConfig(this.addData).then(({data}) => {
                                this.dialogVisible = false;
                                this.$message.success('修改成功！');
                                this.getUpBlackList();
                            });
                        }
                    }
                });
            },
            selectType(type) {
                this.addData.continuedHour = type == -1 ? -1 : "";
            },
            handleRemove(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateEtpConfigStatus({configId: id, type: 3, val: 1}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.getUpBlackList();
                    });
                }).catch(() => {
                });
            },
            handleStatus(id, status) {
                this.$confirm(status == 0 ? '确认拉黑吗？' : '确认解除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateEtpConfigStatus({configId: id, type: 1, val: status}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.getUpBlackList();
                    });
                }).catch(() => {
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getUpBlackList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getUpBlackList();
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addData.coinType = '';
            },
            clearData() {
                this.dialogTitle = "";
                this.addData = {configType: 1, coinList: "", continuedHour: -1, type: -1};
            },
        },
        created() {
            this.getAllSupportCoin();
        }
    }
</script>

<style scoped>

</style>